import { useQuery } from '@tanstack/react-query';
import { DictResponse } from '@spilca/order_ts/v1/order/enum_pb';
import { QUERY_KEYS } from '@monorepo/helpers';
import { translateNormalizedDictionary } from '@monorepo/dictionary';
import { REQUEST_TYPES, useGetRequest } from '@monorepo/requests';

const useGetProductGroup = (
  filter: object | undefined,
  active: string | null = null
) => {
  const getProducts = useGetRequest(
    REQUEST_TYPES.GET_FAST_DEALS_PRODUCT_GROUP_REQUEST
  );

  return useQuery({
    queryKey: [QUERY_KEYS.LIST_FAST_DEALS_PRODUCT_GROUP, filter],
    queryFn: (d): Promise<DictResponse.AsObject> => getProducts({ ...d, active }),
    refetchOnWindowFocus: false,
    retry: false,
    staleTime: 10*60*1000,
    gcTime: 2 * 60 * 1000,
    placeholderData: (previousData) => previousData,
    select: translateNormalizedDictionary(
      ({ name, count }) => `${name} (${count})`,
      null,
      'id',
      (item) => `product-group-${item.id}`
    )
  });
};

export default useGetProductGroup;
